module.exports = "img/betas/video_rooms.7fada3d.png";